import { gql, TypedDocumentNode } from "@apollo/client";

import { FlowsInstance } from "types/generated";

export type FlowsLinkOrganizationsData = {
  flowsInstances: Array<Pick<FlowsInstance, "redirectURL">>;
};

export const GET_FLOWS_INSTANCES: TypedDocumentNode<FlowsLinkOrganizationsData> = gql`
  query GetFlowsInstances {
    flowsInstances {
      redirectURL
    }
  }
`;
